// Where people install the SohozKaj mobile app. A Google Play SEARCH link (not one app's page), so it keeps
// working for the whole family of SohozKaj apps. Used by the mobile menu drawer and the Settings page; the
// contest page links the individual app pages instead (config/contestSite.js).
export const MOBILE_APP_URL = 'https://play.google.com/store/search?q=SohozKaj&c=apps&fpr=false';
